import React from 'react';
import Icon from '../../../components/AppIcon';


const RequirementsSection = ({ formData, onCheckboxChange }) => {
  const equipmentOptions = [
    { id: 'paddleboard', label: 'SUP Tahtası', icon: 'Waves' },
    { id: 'paddle', label: 'Kürek', icon: 'Anchor' },
    { id: 'lifejacket', label: 'Can Yeleği', icon: 'Shield' },
    { id: 'wetsuit', label: 'Dalış Kıyafeti', icon: 'Shirt' },
    { id: 'leash', label: 'Güvenlik İpi (Leash)', icon: 'Link' },
    { id: 'drybag', label: 'Su Geçirmez Çanta', icon: 'Package' }
  ];
  
  const skillLevels = [
    { id: 'beginner', label: 'Başlangıç Seviyesi', description: 'İlk kez deneyecekler için uygun' },
    { id: 'intermediate', label: 'Orta Seviye', description: 'Temel deneyim gerektirir' },
    { id: 'advanced', label: 'İleri Seviye', description: 'Deneyimli paddlerlar için' },
    { id: 'all_levels', label: 'Tüm Seviyeler', description: 'Her seviyeden katılımcı için uygun' }
  ];
  
  const weatherConditions = [
    { id: 'sunny', label: 'Güneşli', icon: 'Sun' },
    { id: 'cloudy', label: 'Bulutlu', icon: 'Cloud' },
    { id: 'windy', label: 'Rüzgarlı', icon: 'Wind' },
    { id: 'calm', label: 'Sakin Deniz', icon: 'Waves' }
  ];
  
  return (
    <div className="bg-card rounded-lg md:rounded-xl lg:rounded-2xl p-4 md:p-6 lg:p-8 shadow-organic">
      <h2 className="text-xl md:text-2xl lg:text-3xl font-semibold text-foreground mb-4 md:mb-5 lg:mb-6">
        Gereksinimler & Koşullar
      </h2>
      <div className="space-y-6 md:space-y-7 lg:space-y-8">
        <div className="bg-warning/10 border border-warning/20 rounded-lg p-4 md:p-5 lg:p-6">
          <div className="flex items-start gap-3">
            <Icon name="AlertTriangle" size={20} className="text-warning flex-shrink-0 mt-0.5" />
            <div>
              <h3 className="text-sm md:text-base font-medium text-foreground mb-2">
                Güvenlik Uyarısı
              </h3>
              <p className="text-xs md:text-sm text-muted-foreground mb-3">
                Tüm katılımcıların aşağıdaki güvenlik kurallarına uyması zorunludur:
              </p>
              <ul className="space-y-1 text-xs md:text-sm text-muted-foreground">
                <li>• Can yeleği kullanımı zorunludur</li>
                <li>• Güvenlik brifingi tamamlanmalıdır</li>
                <li>• Hava koşulları uygun değilse etkinlik iptal edilebilir</li>
                <li>• Alkol veya uyuşturucu etkisi altında katılım yasaktır</li>
              </ul>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default RequirementsSection;